// tslint:disable
﻿/**
 * The version of the OpenAPI document: v8
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {
    RESTSharePointFolder,
} from './';

/**
 * @export
 * @interface RESTRestoreToFoldersConfig
 */
export interface RESTRestoreToFoldersConfig {
    /**
     * Specifies IDs of the SharePoint folders that you want to restore. For more information on how to get such IDs, see [Get SharePoint Folders](#tag/SharePointFolder/operation/SharePointFolder_Get).
     * @type {Array<RESTSharePointFolder>}
     * @memberof RESTRestoreToFoldersConfig
     */
    folders?: Array<RESTSharePointFolder>;
    /**
     * Specifies the target SharePoint list.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    list?: string;
    /**
     * Defines whether the shared links notifications will be sent.
     * @type {boolean}
     * @memberof RESTRestoreToFoldersConfig
     */
    sendSharedLinksNotification?: boolean | null;
    /**
     * Specifies what version of the SharePoint documents will be restored.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    documentVersion?: RESTRestoreToFoldersConfigDocumentVersionEnum;
    /**
     * Specifies the action that will be performed with the last version of the restored SharePoint document on the destination server.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    documentLastVersionAction?: RESTRestoreToFoldersConfigDocumentLastVersionActionEnum;
    /**
     * Specifies the URL of the target SharePoint site.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    siteURL?: string;
    /**
     * Specifies the authentication code. For more information on how to get a device code, see [Get Device Code](#tag/RestoreSession/operation/RestoreSession_DeviceCodeAction). This property is required if you want to use a device code for data restore. 
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    userCode?: string;
    /**
     * Specifies the ID of the Micrisoft Entra application that you want to use for restore.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    applicationId?: string | null;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    applicationCertificatePassword?: string;
    /**
     * Specifies the SSL certificate configured for the Microsoft Entra application that you want to use for data restore. You must provide the certificate as a Base64 string.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    applicationCertificate?: string;
    /**
     * Specifies the user name that you want to use for authenticating to the organization.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    userName?: string;
    /**
     * Specifies a password.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    userPassword?: string;
    /**
     * Specifies the region of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    officeRegion?: RESTRestoreToFoldersConfigOfficeRegionEnum;
    /**
     * Specifies the name of the target Microsoft 365 organization.
     * @type {string}
     * @memberof RESTRestoreToFoldersConfig
     */
    organizationName?: string;
}

/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreToFoldersConfigDocumentVersionEnum {
    All = 'All',
    Last = 'Last'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreToFoldersConfigDocumentLastVersionActionEnum {
    Overwrite = 'Overwrite',
    Merge = 'Merge'
}
/**
 * @export
 * @enum {string}
 */
export enum RESTRestoreToFoldersConfigOfficeRegionEnum {
    Worldwide = 'Worldwide',
    Germany = 'Germany',
    China = 'China',
    UsDefence = 'USDefence',
    UsGovernment = 'USGovernment'
}

